import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { hasAdminAccess, useUserStore } from '@/entities/user'
import { routes } from '@/shared/config'

export function AdminRoute() {
  const { isAuthenticated, isLoading, user } = useUserStore()
  const location = useLocation()

  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.registration} state={{ from: location }} replace />
  }

  if (!hasAdminAccess(user)) {
    return <Navigate to={routes.dashboardLk} replace />
  }

  return <Outlet />
}
